'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _options = _interopRequireDefault(require("Shared/options"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class FrontCandidateForm extends _react.Component {
  state = {
    status_messages: {},
    'candidate[handicap_status]': [],
    'candidate[acceptation]': false,
    activeStep: 0,
    skipped: []
  };
  handleFileChange = _handleFileChange.default.bind(this);
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchProfessionalDomain();
    if (props.type === 'update') {
      component.fetchCandidate();
    }
  }
  fetchCandidate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-self').then(function (xhr, response) {
      const candidate = response.candidate;
      if (!candidate) {
        throw {
          error: 'Candidat introuvable.'
        };
      }
      delete candidate.cv_download;
      candidate.now_situation = candidate.now_situation || {};
      candidate.tsa_diagnostic = candidate.tsa_diagnostic || {};
      candidate.rqth = candidate.rqth || {};
      const tsa_file = ((candidate.tsa_diagnostic || {}).file || []).map(function (data) {
        const descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      if (candidate.tsa_diagnostic) {
        delete candidate.tsa_diagnostic.file;
      }
      const rqth_file = ((candidate.rqth || {}).file || []).map(function (data) {
        const descriptor = {
          ...data,
          status: 'uploaded',
          filename: data.url.slice(data.url.lastIndexOf('/') + 1),
          pdf: true
        };
        return descriptor;
      });
      if (candidate.rqth) {
        delete candidate.rqth.file;
      }
      let update = {};
      update = {
        ...update,
        ...(0, _getStateFromObject.default)({
          data: candidate,
          model: 'candidate'
        })
      };
      update.read_only_diag = props.type === 'update';
      update.read_only_rqth = props.type === 'update' && rqth_file && rqth_file.length ? true : false;
      component.setState({
        ...update,
        'candidate[tsa_diagnostic][file]': tsa_file,
        '__files-candidate[tsa_diagnostic][file]': tsa_file,
        'candidate[rqth][file]': rqth_file,
        '__files-candidate[rqth][file]': rqth_file,
        fetch_id: (0, _uniqid.default)(),
        has_cv: response.has_cv,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const candidate = (0, _getFormData.default)({
      state: state,
      pattern: 'candidate['
    });
    const url = props.type === 'update' ? '/candidate/update-my-record' : '/candidate/create';
    qwest.post(url, candidate).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: props.type === 'update' ? response.info : 'Nous vous remercions d’avoir créé votre compte. Vous allez être contacté prochainement par email pour discuter de votre demande et avoir accès à nos services. Si besoin, contactez-nous sur contact@aspiejob.org',
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      if (props.type !== 'update') {
        window.setTimeout(function () {
          component.login(response.login, response.pass, response.id);
        }, 3000);
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  login = (login, pass, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/login', {
      login: login,
      password: pass
    }).then(function (xhr, response) {
      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      component.setState({
        loading: false
      });
      window.setTimeout(function () {
        app.navigateTo((0, _Routes.URL)('CandidateAccount'));
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        loading: false,
        ...(0, _getErrorsFromResponse.default)({
          response: response,
          error: response?.error
        })
      });
    });
  };
  handleCheckboxChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleDepChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const value = event.value;
    const name = event.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.fetchDepartment(event.value);
  };
  fetchDepartment = department => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.get(`https://geo.api.gouv.fr/departements?nom=${department}&limit=5`).then(data => {
      component.setState({
        deps: JSON.parse(data.response)
      });
      component.setState({
        show_suggestions: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  isStepSkipped = step => {
    const component = this,
      props = this.props,
      state = this.state;
    return state.skipped.includes(step);
  };
  handleNext = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    newSkipped.push(state.activeStep);
    component.setState({
      activeStep: state.activeStep + 1,
      skipped: newSkipped
    });
  };
  handleBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    let prevStep = state.activeStep - 1;
    const index = newSkipped.indexOf(prevStep);
    if (index > -1) {
      newSkipped.splice(index, 1);
    }
    newSkipped.filter(function (step) {
      return step !== prevStep;
    });
    component.setState({
      activeStep: state.activeStep - 1,
      skipped: newSkipped
    });
  };
  handleSkip = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    newSkipped.push(state.activeStep);
    component.setState({
      activeStep: state.activeStep + 1,
      skipped: newSkipped
    });
  };
  handleReset = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      activeStep: 0
    });
  };
  getJobOptions = job => {
    const component = this,
      props = this.props,
      state = this.state;
    const job_option = _options.default[job];
    let job_items = job_option.map(function (job_item, i) {
      let output = /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: job_item.value,
        key: job_item.value
      }, job_item.label);
      return output;
    });
    return job_items;
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/professional-domain/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  selectDept = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'candidate[department]': e.target.innerText || ''
    });
    component.setState({
      show_suggestions: false
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const depts_suggestions = (state.show_suggestions ? state.deps || [] : []).map(function (dep) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: dep.nom,
        onClick: component.selectDept
      }, dep.nom);
    });
    const user_infos_section = props.type === 'update' ? undefined : /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations de connexion"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[login]'],
      name: "candidate[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[password]'],
      name: "candidate[password]",
      type: "password",
      label: "Mot de passe (minimum 12 caract\xE8res) ",
      autocomplete: "new-password",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Coordonn\xE9es"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[lastname]'],
      name: "candidate[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[firstname]'],
      name: "candidate[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      label: "Date de naissance",
      name: "candidate[birthdate]",
      onChange: component.handleChange,
      value: state['candidate[birthdate]'],
      error: state.status_messages?.['candidate[birthdate]']?.error
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 8,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[home_phone_number]'],
      name: "candidate[home_phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[phone_number]'],
      name: "candidate[phone_number]",
      type: "text",
      label: "T\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_1]'],
      name: "candidate[address][line_1]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Compl\xE9ment d'adresse",
      onChange: component.handleChange,
      value: state['candidate[address][line_2]'],
      name: "candidate[address][line_2]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['candidate[address][postal_code]'],
      name: "candidate[address][postal_code]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Ville",
      onChange: component.handleChange,
      value: state['candidate[address][city]'],
      name: "candidate[address][city]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "D\xE9partement",
      onChange: component.handleDepChange,
      value: state['candidate[department]'],
      name: "candidate[department]",
      status: state.status_messages
    }), depts_suggestions.length ? /*#__PURE__*/_react.default.createElement("ul", {
      className: "sugestion-departement"
    }, depts_suggestions) : undefined));
    const cv_section = props.type === 'update' ? undefined : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "J'ai fait mon CV",
      onChange: component.handleRadioChange,
      value: "J'ai fait mon CV",
      color: "primary",
      name: "candidate[cv_status]"
    }), "J'ai fait mon cv et je vous le communique ci-joint"), state['candidate[cv_status]'] === "J'ai fait mon CV" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      onChange: component.handleFileChange,
      name: "candidate[cv_download]",
      data: state,
      status: state.status_messages,
      accept: ".pdf,.jpg,.png,.odt,.gif,.docx,.jpeg",
      label: "Joindre mon CV (PDF,JPG)"
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[cv_status]'] === "Je n’ai pas fait mon CV et je souhaite de l’aide pour le rédiger",
      onChange: component.handleRadioChange,
      value: "Je n\u2019ai pas fait mon CV et je souhaite de l\u2019aide pour le r\xE9diger",
      color: "primary",
      name: "candidate[cv_status]"
    }), "Je n\u2019ai pas fait mon CV et je souhaite de l\u2019aide pour le r\xE9diger"), /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, state.status_messages?.['candidate[cv_status]']?.error));
    const has_diag = state['candidate[tsa_current_status]'] === 'Diagnostiqué';
    const has_rqth = state['candidate[rqth][status]'] === 'Oui';
    const has_no_diag = state['candidate[tsa_current_status]'] === 'Non diagnostiqué';
    const data_agreement = has_diag || has_rqth ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "legal-form-smaller-text-title"
    }, "Pourquoi nous demandons votre diagnostic."), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Aspiejob accompagne exclusivement les personnes ayant un trouble du spectre de l\u2019autisme sans d\xE9ficience. C\u2019est la raison pour laquelle la communication de votre diagnostic est une condition n\xE9cessaire \xE0 votre inscription. Votre diagnostic est aussi un outil pr\xE9cieux pour bien comprendre vos besoins."), /*#__PURE__*/_react.default.createElement("h3", {
      className: "legal-form-smaller-text-title"
    }, "Vos donn\xE9es sont en s\xE9curit\xE9"), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Cette base de donn\xE9es est enti\xE8rement s\xE9curis\xE9e et habilit\xE9e \xE0 recevoir des informations m\xE9dicales confidentielles."), /*#__PURE__*/_react.default.createElement("h3", {
      className: "legal-form-smaller-text-title"
    }, "Documents accept\xE9s"), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Sont accept\xE9s tout diagnostic ou pr\xE9-diagnostic \xE9tabli par un professionnel de sant\xE9 habilit\xE9\xA0: psychiatre, p\xE9dopsychiatre, neurologue, psychologue, ou \xE9quipe pluridisciplinaire (CRA, h\xF4pital\u2026).", /*#__PURE__*/_react.default.createElement("br", null), "Ne sont pas accept\xE9s les autodiagnostics."), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En cochant cette case, vous (le candidat majeur ou le repr\xE9sentant l\xE9gal du candidat faisant l\u2019objet d\u2019une mesure de tutelle ou de curatelle) consentez \xE0 la collecte et au traitement par l\u2019association Aspiejob de la donn\xE9e relative au diagnostic du candidat afin d\u2019adapter les services rendus par Aspiejob. Vous pourrez retirer votre consentement \xE0 tout moment, sans avoir \xE0 en justifier.",
      name: "candidate[data_agreement]",
      value: state['candidate[data_agreement]'] === true,
      status: state.status_messages
    }))) : has_no_diag ? (0, _getFormStatus.default)({
      error: 'Fournir le bilan diagnostic est indispensable pour votre ' + 'inscription'
    }) : undefined;
    return /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      className: "u-full-width",
      action: "/candidate/create"
    }, user_infos_section, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Ma situation personnelle"), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form title-candidate-form--sub"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "J\u2019ai un diagnostic")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: has_diag,
      onChange: component.handleRadioChange,
      value: "Diagnostiqu\xE9",
      color: "primary",
      name: "candidate[tsa_current_status]",
      disabled: state.read_only_diag
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[tsa_current_status]'] === "Non diagnostiqué",
      onChange: component.handleRadioChange,
      value: "Non diagnostiqu\xE9",
      color: "primary",
      name: "candidate[tsa_current_status]",
      disabled: state.read_only_diag
    }), "Non", /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, state.status_messages?.["candidate[tsa_current_status]"]?.error)), has_diag ? /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-left-25\r u-padding-left-25 -u-margin-top-25 u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      data: state,
      accept: ".pdf, .jpg, .jpeg,",
      onChange: component.handleFileChange,
      name: "candidate[tsa_diagnostic][file]",
      multiple: true,
      status: state.status_messages,
      label: "Joindre mon diagnostic (.pdf, .jpg, .jpeg)",
      "read-only": props.type === 'update'
    })) : undefined, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form title-candidate-form--sub"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "J\u2019ai une RQTH "), ' ', "(Reconnaissance de Travailleur Handicap\xE9)"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 3,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: has_rqth,
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "candidate[rqth][status]",
      disabled: state.read_only_rqth
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 3,
      className: "custom-grid",
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['candidate[rqth][status]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "candidate[rqth][status]",
      disabled: state.read_only_rqth
    }), "Non", /*#__PURE__*/_react.default.createElement("span", {
      className: "c-form-radio--error"
    }, state.status_messages?.["candidate[tsa_current_status]"]?.error)), state['candidate[rqth][status]'] === "Oui" ? /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-left-25\r u-padding-left-25 -u-margin-top-25 u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_FileInput.default, {
      data: state,
      accept: ".pdf, .jpg, .jpeg,",
      onChange: component.handleFileChange,
      name: "candidate[rqth][file]",
      multiple: true,
      status: state.status_messages,
      label: "Joindre mon attestation de RQTH (.pdf, .jpg, .jpeg)",
      "read-only": state.read_only_rqth
    })) : undefined, data_agreement), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Se d\xE9placer"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je prend les transports en commun mais j\u2019ai des difficult\xE9es d\u2019ordre sensoriel (bruit notamment) qui peuvent m\u2019amener \xE0 \xE9viter ce type de  transport",
      name: "candidate[displacement_difficulties][difficulte]",
      value: state['candidate[displacement_difficulties][difficulte]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je prend les transports en commun",
      name: "candidate[displacement_difficulties][transport_commun]",
      value: state['candidate[displacement_difficulties][transport_commun]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je conduis",
      name: "candidate[displacement_difficulties][conduit]",
      value: state['candidate[displacement_difficulties][conduit]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je me d\xE9place \xE0 v\xE9lo",
      name: "candidate[displacement_difficulties][velo]",
      value: state['candidate[displacement_difficulties][velo]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Je me d\xE9place \xE0 pied",
      name: "candidate[displacement_difficulties][a_pied]",
      value: state['candidate[displacement_difficulties][a_pied]'] === true,
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Votre situation actuelle"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En poste CDI/CDD/Fonctionnaire",
      name: "candidate[now_situation][employed]",
      value: state['candidate[now_situation][employed]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En formation",
      name: "candidate[now_situation][training]",
      value: state['candidate[now_situation][training]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "En arr\xEAt maladie",
      name: "candidate[now_situation][sick_leave]",
      value: state['candidate[now_situation][sick_leave]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sans emploi - indemnis\xE9",
      name: "candidate[now_situation][jobless_paid]",
      value: state['candidate[now_situation][jobless_paid]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sans emploi - non indemnis\xE9",
      name: "candidate[now_situation][jobless_not_paid]",
      value: state['candidate[now_situation][jobless_not_paid]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[situation_info]"] || '',
      name: "candidate[situation_info]",
      label: "Pour quel besoin contactez-vous aujourd'hui Aspiejob ? (Recherche emploi, prise de poste, maintien en emploi) et quelles sont vos attentes vis \xE0 vis d'Aspiejob ?",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[job_support]"] || '',
      name: "candidate[job_support]",
      label: "Si vous b\xE9n\xE9ficiez d'un accompagnement vers l'emploi pr\xE9cisez : (SPE, PEA, association, etc...)",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[other_support]"] || '',
      name: "candidate[other_support]",
      label: "Si vous b\xE9n\xE9ficiez d'un autre accompagnement autre, pr\xE9cisez : (Assistante sociale, Educateur, Association, Th\xE9rapeute, etc...)",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[pro_project]"] || '',
      name: "candidate[pro_project]",
      label: "Avez-vous un projet professionnel ? Si oui lequel ?",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      className: "u-full-width u-no-margins",
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations compl\xE9mentaires"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["candidate[competences_interets]"] || '',
      name: "candidate[competences_interets]",
      label: "Mes comp\xE9tences et int\xE9r\xEAts",
      multiline: true,
      rows: "5",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[geographic_sector]'],
      name: "candidate[geographic_sector]",
      type: "text",
      label: "Secteur g\xE9ographique de ma recherche",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['candidate[working_rythm_desired_hours]'],
      name: "candidate[working_rythm_desired_hours]",
      type: "text",
      label: "Rythme de travail - horaires souhait\xE9s",
      status: state.status_messages
    })), cv_section, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleChange,
      label: "J'accepte les conditions g\xE9n\xE9rales d'utilisation",
      name: "candidate[cgu_accepted]",
      value: state['candidate[cgu_accepted]'] === true,
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement("a", {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "u-margin-top-10 c-link"
    }, "Voir les CGU"))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes,
      className: "u-margin-top-15"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "J\u2019ai bien pris connaissance de la politique de confidentialit\xE9 de l\u2019association Aspiejob",
      name: "candidate[privacy_policy]",
      value: state['candidate[privacy_policy]'] === true,
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement("a", {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "u-margin-top-10 c-link"
    }, "Lire la politique de confidentialit\xE9")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes,
      className: "u-margin-top-15"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "J\u2019accepte que l\u2019association Aspiejob m\u2019envoie des informations sur les actions de l\u2019association li\xE9es \xE0 l\u2019accompagnement professionnel des personnes diagnostiqu\xE9es avec un trouble du spectre autistique",
      name: "candidate[infos_news]",
      value: state['candidate[infos_news]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "L'association Aspiejob est le responsable de traitement des donn\xE9es personnelles collect\xE9es dans le cadre du pr\xE9sent formulaire aux fins de gestion administrative des formulaires, de traitement des demandes de contact et de mise en relation avec des professionnels, et, sous r\xE9serve de votre consentement, d\u2019envoi d\u2019informations sur ses actions li\xE9es \xE0 l\u2019association."), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Les donn\xE9es sont destin\xE9es \xE0 l'association Aspiejob. La base l\xE9gale du traitement est l\u2019ex\xE9cution de mesures pr\xE9contractuelles ou notre int\xE9r\xEAt l\xE9gitime pour les donn\xE9es qui exc\xE8deraient ce qui est strictement n\xE9cessaire \xE0 l'ex\xE9cution de mesures pr\xE9contractuelles. La base l\xE9gale du traitement de vos donn\xE9es de sant\xE9 est votre consentement, tout comme pour l\u2019envoi d\u2019informations relatives aux actions de l\u2019association. Aspiejob peut transmettre vos coordonn\xE9es \xE0 Aspiejob Conseil ou aux job coach collaborant avec l\u2019association pour l\u2019accompagnement des candidats dans leur int\xE9gration professionnelle et \xE0 la soci\xE9t\xE9 3h18 responsable de la gestion administrative des dossiers."), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Conform\xE9ment \xE0 la r\xE9glementation applicable en mati\xE8re de donn\xE9es personnelles, vous b\xE9n\xE9ficiez d\u2019un droit d\u2019acc\xE8s aux donn\xE9es vous concernant, d\u2019un droit de rectification, d\u2019un droit \xE0 l\u2019effacement des donn\xE9es, du droit de retirer votre consentement au traitement des donn\xE9es, du droit \xE0 la limitation du traitement, du droit \xE0 la portabilit\xE9 des donn\xE9es, du droit de vous opposer au traitement pour des raisons tenant \xE0 votre situation particuli\xE8re, du droit de formuler des directives sur vos donn\xE9es post-mortem, ainsi que du droit d\u2019introduire une r\xE9clamation aupr\xE8s de la CNIL."), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Pour exercer ces diff\xE9rents droits aupr\xE8s de l'Association Aspiejob, vous pouvez envoyer un email \xE0 l\u2019adresse suivante : contact@aspiejob ou un courrier postal \xE0 l\u2019adresse suivante : Association Aspiejob - \xE0 l\u2019attention D\xE9l\xE9gu\xE9 \xE0 la Protection des Donn\xE9es (DPO) \u2013 8, rue des Acacias \u2013 69740 Genas"), /*#__PURE__*/_react.default.createElement("p", {
      className: "legal-form-smaller-text"
    }, "Pour plus d\u2019information, nous vous invitons \xE0 consulter notre politique de Protection des Donn\xE9es Personnelles :", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "u-margin-top-10 c-link"
    }, "Lire la politique de confidentialit\xE9")), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20\r u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour mon dossier' : 'Valider la création de mon compte', loader)));
  }
}
exports.default = FrontCandidateForm;
